import { Link } from "react-router-dom"; // Import Link for navigation
import "bootstrap/dist/css/bootstrap.min.css";
import "./Home.css"; // Ensure this CSS file is created and linked
import { FaBook, FaFileInvoiceDollar, FaBuilding, FaChartLine, FaLaptopCode } from "react-icons/fa";

const services = [
  {
    title: "Bookkeeping",
    description:
      "Get the peace of mind to focus on running your business, thanks to our triple-checked financial statements.",
    linkText: "Read More →",
    link: "/bookkeeping", // Correct path
    icon: <FaBook />,
  },
  {
    title: "Tax",
    description:
      "Stop worrying about tax prep, with expert support for federal and state income tax filings, 1099s, and Delaware Franchise.",
    linkText: "Read More →",
    link: "/tax", // Correct path
    icon: <FaFileInvoiceDollar />,
  },
  {
    title: "USA Business Incorporation",
    description:
      "Delegate your operational tasks to us so you can focus on scaling your business. We handle your back office efficiently.",
    linkText: "Read More →",
    link: "/usa", // Correct path
    icon: <FaBuilding />,
  },
  {
    title: "CFO",
    description:
      "Need help with budgeting, KPI tracking, board decks, or fundraising? Our CFOs advise and prepare you for what’s next.",
    linkText: "Read More →",
    link: "/cfo", // Correct path
    icon: <FaChartLine />,
  },
  {
    title: "Zoho Implementation",
    description:
      "Streamline your business operations with our expert Zoho implementation services, including customization, integration, and training.",
    linkText: "Read More →",
    link: "/zoho",
    icon: <FaLaptopCode />,
  },
];

function ServiceSection() {
  return (
    <div className="service-section container mt-2 mb-5">
      {/* Section Heading */}
      <div className="text-center mb-4">
        <h1 className="section-title4">What We Do</h1>
        <p className="section-description">
          Whether you’re looking to strengthen your decision-making or want a
          hands-off compliance solution, we tailor our services to your needs.
        </p>
      </div>

      {/* Service Cards */}
      <div className="row g-4 mb-4">
        {/* First row - 3 cards */}
        {services.slice(0, 3).map((service, index) => (
          <div key={index} className="col-md-4">
            <div className="service-card text-center shadow-lg h-100">
              <div className="service-card-body">
                <div className="service-icon mb-3">{service.icon}</div>
                <h5 className="service-title">{service.title}</h5>
                <p className="service-description">{service.description}</p>
                <Link to={service.link} className="service-link">
                  {service.linkText}
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
      
      {/* Second row - 2 centered cards */}
      <div className="row justify-content-center g-4">
        {services.slice(3).map((service, index) => (
          <div key={index + 3} className="col-md-6 col-lg-4">
            <div className="service-card text-center shadow-lg h-100">
              <div className="service-card-body">
                <div className="service-icon mb-3">{service.icon}</div>
                <h5 className="service-title">{service.title}</h5>
                <p className="service-description">{service.description}</p>
                <Link to={service.link} className="service-link">
                  {service.linkText}
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ServiceSection;